/*
 xu.ruliang 2017/04/20
 */
"use strict";
angular.module('batchOperationframeModule', [])
    .controller('batchOperationframeCtrl', ['$scope', '$modalInstance', 'sTitle', 'sContent', function($scope, $modalInstance, sTitle, sContent) {
        initData();
        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            $scope.title = sTitle;
            $scope.content = sContent.split("、");
            $scope.num=$scope.content.length;
            if($scope.num>2){
                $scope.content=$scope.content.slice(0,2);
            };
        }
        /**
         * [confirm 确定]
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $modalInstance.close();
        };
        /**
         * [cancel 取消]
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

    }]);
